import { useContext, useEffect } from 'react'

import useAPIRequest from 'src/hooks/useAPIRequest'
import { rootApiClient } from 'src/routes/root'

import UIActions from '../../actions'
import { UIContext, UIDispatchContext } from '../../constants'

const useUI = () => {
    const context = useContext(UIContext)
    const dispatch = useContext(UIDispatchContext)

    const { callAPI: getApplications, result: applications } = useAPIRequest(rootApiClient.getApplications)

    useEffect(() => {
        if (applications?.length) {
            dispatch({ type: UIActions.STORE_APPLICATIONS, payload: applications })
        }
    }, [applications])

    if (context === undefined) {
        throw new Error('UIContext must be within provider')
    }

    return { ...context, fetchApplications: () => getApplications({}) }
}

export default useUI
